import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const apiAccessToken = localStorage.getItem('api_access_token');
        const apiAccessType = localStorage.getItem('api_token_type');
        if (apiAccessToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: apiAccessType + ' ' + apiAccessToken
                }
            });
        }

        return next.handle(request);
    }
}